import {getBet} from '../api/getBet';
import {setGetBetAction} from '../action';

const setGetBet = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getBet(params);
    
            if (data.status === 'success') {
                dispatch(setGetBetAction(data.data));
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetBet
}